import script from "./HowToArriveSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./HowToArriveSection.vue?vue&type=script&setup=true&lang=ts"

import "./HowToArriveSection.vue?vue&type=style&index=0&id=3f9bf63a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f9bf63a"]])

export default __exports__